import {useEffect, useRef, useState} from "react";
import StarRating from "./StarRating";
import Loader from "./Loader";
import ErrorMessage from "./ErrorMessage";
import {useKey} from "../useKey";

const KEY = process.env.REACT_APP_API_KEY;

export default function MovieDetails({ selectedId, onCloseMovie, watchedMovies,
                                         onAddWatched, error, setError }) {
    const [movie, setMovie] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [userRating, setUserRating] = useState('');

    const countRef = useRef(0);

    useEffect(() => {
        if(userRating) countRef.current++;
    }, [userRating]);

    const isWatched = watchedMovies.map(m => m.imdbID).includes(selectedId);
    const watchedUserRating = watchedMovies.find(m => m.imdbID === selectedId)?.userRating;

    const {
        Title: title,
        Poster: poster,
        Year: year,
        Runtime: runtime ,
        imdbRating,
        Plot: plot,
        Released: released,
        Actors: actors,
        Director: director,
        Genre: genre,
    } = movie;

    function handleAdd(){
        const newWatchedMovie = {
            imdbID: selectedId,
            title,
            year,
            poster,
            imdbRating: Number(imdbRating) ?? 0,
            runtime: runtime.split(' ').at(0) === 'N/A' ? 0 : runtime.split(' ').at(0) ,
            userRating,
            countRatingDecisions: countRef.current
        };

        onAddWatched(newWatchedMovie);
        onCloseMovie();
    }

    useKey('Escape', onCloseMovie);

    useEffect(() => {
        async function getMovieDetails(){
            try {
                setIsLoading(true);
                setError('');
                const res = await fetch(`https://www.omdbapi.com/?apikey=${KEY}&i=${selectedId}`);

                if(!res.ok) throw new Error('Something went wrong with fetching movies');

                const data = await res.json();
                if(data.Response === 'False') throw new Error('Movie not found');
                setMovie(data);
            }
            catch(err){
                setError(err.message);
            }
            finally{
                setIsLoading(false);
            }
        }

        getMovieDetails();
    }, [selectedId, setError]);

    useEffect(() => {
        if(!title) return;
        document.title = `Movie | ${title}`;

        return function(){
            document.title = 'usePopcorn';
        }
    }, [title])

    return <div className='details'>
        {isLoading ? <Loader/> : error ? <ErrorMessage message={error}/> :(
            <>
                <header>

                    <button className='btn-back' onClick={onCloseMovie}>&larr;</button>
                    <img src={poster} alt={`Poster of ${title} movie`} />
                    <div className='details-overview'>
                        <h2>{title}</h2>
                        <p>{released} &bull; {runtime}</p>
                        <p>{genre}</p>
                        <p><span>⭐</span>{imdbRating} IMDb rating</p>
                    </div>
                </header>

                <section>
                    <div className='rating'>
                        {isWatched ?
                            <p>You rated this movie with {watchedUserRating} <span>⭐</span></p>
                            : (<>
                            <StarRating maxRating={10} size={24} key={selectedId} onSetRating={setUserRating} />

                            {userRating > 0 && <button
                                className='btn-add' onClick={handleAdd}>+ Add to list
                            </button>}
                        </>)}
                    </div>

                    <p><em>{plot}</em></p>
                    <p>Starring {actors}</p>
                    <p>Directed by {director}</p>
                </section>
            </>
        )}
    </div>
}